export default __webpack_public_path__ + "static/media/1751.0d72d9dd.png";